import React, { useState } from "react";
import Select from "react-select";

interface OptionType {
  value: string;
  label: string;
}

interface SelectorProps {
  options: OptionType[];
  isMulti: boolean;
  onChange: (selectedOption: any) => void;
  value: any;
  placeholder: string;
  selectAll?: () => void;
  isButtonClicked?: boolean;
  handleButtonClick?: () => void;
}

const Selector: React.FC<SelectorProps> = ({
  options,
  isMulti,
  onChange,
  value,
  placeholder,
  selectAll,
  isButtonClicked,
  handleButtonClick,
}) => {
  const handleClick = () => {
    if (selectAll && handleButtonClick) {
      handleButtonClick(); // Toggle button click state
      selectAll(); // Perform the select all action
      onChange([]); // Clear the selected values
    }
  };

  return (
    <div className="selector">
      <Select
        options={options}
        isMulti={isMulti}
        onChange={onChange}
        value={value}
        placeholder={placeholder}
        isSearchable
      />
      {selectAll && (
        <button
          onClick={handleClick}
          className={`select-all-button ${isButtonClicked ? "clicked" : ""}`}
        >
          {isButtonClicked ? "Todos selecionados" : "Todos"}
        </button>
      )}
    </div>
  );
};

export default Selector;
